let head = 'http://localhost:3018/'
head = 'https://api.sz-huayida.cn/'
head = 'https://tihuoma.yaodianma.com/api/'
head = 'https://admin.diandianchuangyi.com/api/'

// eslint-disable-next-line import/no-anonymous-default-export
export default head
